import { Award, MapPin, ShieldCheck } from "lucide-react";
import { IMAGES } from "@/lib/constants";

const QUALS = [
  { icon: Award, label: "Mountain Training Qualified" },
  { icon: ShieldCheck, label: "Outdoor First Aid · DBS Checked" },
  { icon: MapPin, label: "Local to Lancashire & Cumbria" },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-24 h-24 rounded-full bg-[#3FB6B2]/15 blur-2xl" />
            <img
              src={IMAGES.about}
              alt="Instructor on the fells"
              className="relative w-full h-[520px] md:h-[640px] object-cover rounded-2xl shadow-xl"
            />
            <div className="absolute -bottom-6 -right-6 bg-[#5C5654] text-white p-6 rounded-2xl shadow-2xl max-w-[260px] hidden md:block">
              <div
                className="text-3xl font-light"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                "Climb with
                <br />
                <span style={{ color: "#3FB6B2" }}>confidence."</span>
              </div>
              <div className="mt-3 text-xs tracking-widest uppercase text-white/60">
                — Founder, FS Mountain Skills
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <div className="overline mb-4">About</div>
          <h2
            className="font-display text-4xl md:text-5xl lg:text-6xl font-light text-[#2A2726] tracking-tight leading-[1.05]"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Built on local rock.
            <br />
            <span className="italic font-extralight text-[#5C5654]">
              Years of practice.
            </span>
          </h2>

          <div className="mt-8 space-y-5 text-[#5C5654] text-[17px] leading-relaxed">
            <p>
              FS Mountain Skills is a small, focused climbing instruction
              company operating across the gritstone edges of Lancashire and
              the volcanic crags of the Lake District. We're not a big-box
              outdoor centre — every session is delivered personally, on real
              rock, by a Mountain Training qualified instructor.
            </p>
            <p>
              Whether you've never tied into a rope before or you're a seasoned
              indoor climber making the leap outside, the goal is the same:
              build genuine, lasting skills in the most beautiful classroom in
              England.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {QUALS.map(({ icon: Icon, label }) => (
              <div
                key={label}
                className="flex items-center gap-3 p-4 rounded-xl border border-black/5 bg-[#F9F8F6]"
                data-testid={`qual-${label.split(" ")[0].toLowerCase()}`}
              >
                <div
                  className="w-10 h-10 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: "rgba(63,182,178,0.12)" }}
                >
                  <Icon size={18} style={{ color: "#3FB6B2" }} />
                </div>
                <span className="text-sm font-medium text-[#2A2726]">
                  {label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
